import apiFetch from '../../apiFetch'

export default function (stockDossierId, typeButton, confirm, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/ConfirmPhotoDateStock/${stockDossierId}`, method: 'PUT', body: { typeButton: typeButton, confirm: confirm }, token: token, lastAccessDate })
}
